import Modal from 'react-modal';
import { useState, useEffect } from 'react';
import { dateToday, hoursNow, setMaskGeneric, removeItemArray, makeSearch, showMessageError, } from '../../../classes/functions';
import './inventory.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory } from 'react-router-dom';
import { FaArrowAltCircleLeft, FaArrowLeft, FaArrowRight, FaCog, FaSearch, FaTrash } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import InputDate from '../../../components/Inputs/Date/index.js';

export default function Inventory() {
  let delay;
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);

  const [listStatus, setListStatus] = useState([]);

  const [status, setStatus] = useState('');
  const [hour, setHour] = useState('');
  const [description, setDescription] = useState('');
  const [observation, setObservation] = useState('');
  const [product_from, setProductFrom] = useState('');
  const [product_to, setProductTo] = useState('');
  const [address_from, setAddressFrom] = useState('');
  const [address_to, setAddressTo] = useState('');
  const [warehouse_from, setWarehouseFrom] = useState('');
  const [warehouse_to, setWarehouseTo] = useState('');

  const [listWarehousesFrom, setListWarehousesFrom] = useState([]);
  const [listWarehousesTo, setListWarehousesTo] = useState([]);
  const [listAddressesFrom, setListAddressesFrom] = useState([]);
  const [listAddressesTo, setListAddressesTo] = useState([]);
  const [listProductsFrom, setListProductsFrom] = useState([]);
  const [listProductsTo, setListProductsTo] = useState([]);
  const [selected_items, setSelectedItems] = useState([]);

  //Paginação
  const [list, setList] = useState([]);
  const [listAll, setListAll] = useState([]);
  const [listFinal, setListFinal] = useState([]);
  const [termSearch, setTermSearch] = useState('');
  const [activePage, setActivePage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [registerFrom, setRegisterFrom] = useState(0);
  const [registerTo, setRegisterTo] = useState(0);
  const [total, setTotal] = useState(0);
  const [itensByPage, setItensByPage] = useState(50);

  const [infos, setInfos] = useState({
    date: ""
  });

  useEffect(() => {
    async function loadInventory() {
      setStatus('001');
      setInfos((prevState) => ({...prevState, date: dateToday}));
      setHour(hoursNow);
      setCarrying(false);

      getData();
    }

    loadInventory();

  }, []);

  function validForm() {
    if (description == '' || observation == '' || selected_items.length == 0) {
      toast.error('Preencha todos os campos com * para continuar');
      return false
    }

    return true;
  }

  function save(e) {
    setCarrying(true);
    e.preventDefault();

    if (!validForm()) {
      setCarrying(false);
      return false;
    }

    var data = {
      row: {
        description: description,
        observation: observation,
      },
      rows: selected_items,
    }

    api.post("/api/inventory/post", data)
      .then((response) => {
        toast.success('Registro inserido com sucesso.');
        history.push('/inventory');
      }).catch((error) => {
        showMessageError(error.response.data);
        console.log(error);
        setCarrying(false);
      });
  }

  function cancel() {
    history.push('/inventory');
  }

  async function getData() {
    api.get("/api/inventory/getDataPage")
      .then((response) => {
        setListStatus(response.data.status);

        setCarrying(false);
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
  }

  function addItemInventory() {
    if (warehouse_from == '' && warehouse_to == '' && product_from == '' && product_to == '' && address_from == '' && address_to == '') {
      toast.error('Selecione pelo menos um item para pesquisa!');
      return false;
    } else {
      setCarrying(true);

      let data = {
        data: {
          warehouse_from: warehouse_from,
          warehouse_to: warehouse_to,
          product_from: product_from,
          product_to: product_to,
          address_from: address_from,
          address_to: address_to,
        }
      }

      api.post("/api/inventory/getListItemsToInventory", data)
        .then((response) => {
          setSelectedItems(selected_items.concat(response.data.list));

          setList(selected_items.concat(response.data.list));
          setListAll(selected_items.concat(response.data.list));
          setPagination(selected_items.concat(response.data.list), itensByPage, termSearch);

          setProductFrom('');
          setProductTo('');
          setAddressFrom('');
          setAddressTo('');
          setWarehouseFrom('');
          setWarehouseTo('');

          setCarrying(false);
        }).catch((error) => {
          showMessageError(error.response.data);
          console.log(error);
          setCarrying(false);
        });
    }
  }

  function clearList() {
    setList([]);
    setListAll([]);
    setListFinal([]);
    setTermSearch('');
    setActivePage(0);
    setTotalPage(0);
    setRegisterFrom(0);
    setRegisterTo(0);
    setTotal(0);
    setItensByPage(50);
    setSelectedItems([]);
  }

  function removeItem(index) {
    setSelectedItems(removeItemArray(selected_items, index));
    setList(removeItemArray(selected_items, index));
    setListAll(removeItemArray(selected_items, index));
    setPagination(removeItemArray(selected_items, index), itensByPage, termSearch);
  }

  // Search and pagination
  function search(e) {
    setTermSearch(e.target.value);
    setPagination(listAll, itensByPage, e.target.value);
  }

  function setPagination(aux_list_all = listAll, itensPerPage = itensByPage, auxTermSearch = termSearch) {
    let aux_list_total = [];

    aux_list_total = makeSearch(aux_list_all, ['warehouse_description', 'address_description', 'product_description'], auxTermSearch);

    setTotal(aux_list_total.length);

    if (aux_list_total.length > 0) {
      setTotalPage(parseInt(aux_list_total.length / itensPerPage) + 1);
      let aux_list = [];
      let final_list = [];

      aux_list_total.forEach((element, index) => {
        if ((index + 1) % itensPerPage === 0) {
          aux_list.push(element);
          final_list.push(aux_list);
          aux_list = [];
        } else {
          aux_list.push(element);
        }

        if ((aux_list_total.length === index + 1) && (aux_list !== [])) {
          final_list.push(aux_list);
          aux_list = [];
        }
      });

      setList(final_list[0]);
      setListFinal(final_list);
      setRegisterFrom(1);
      setRegisterTo(final_list[0].length);
    } else {
      setList([]);
      setListFinal([]);
      setRegisterFrom(0);
      setRegisterTo(0);
    }
  }

  function nextPage() {
    if ((activePage) <= totalPage - 2) {
      setList(listFinal[activePage + 1]);
      setActivePage(activePage + 1);

      setRegisterTo((((activePage + 1) * itensByPage) + 1) + (itensByPage - 1));
      if (((((activePage + 1) * itensByPage) + 1) + (itensByPage - 1)) > total) {
        setRegisterTo(total);
      }
      setRegisterFrom(((activePage + 1) * itensByPage) + 1);
    }
  }

  function lastPage() {
    setList(listFinal[totalPage - 1]);
    setActivePage(totalPage - 1);
    setRegisterTo(total);
    setRegisterFrom(((totalPage - 1) * itensByPage) + 1);
  }

  function firstPage() {
    setList(listFinal[0]);
    setActivePage(0);
    setRegisterFrom(1);
    setRegisterTo(listFinal[0].length);
  }

  function previewPage() {
    if ((activePage - 1) >= 0) {
      setList(listFinal[activePage - 1]);
      setActivePage(activePage - 1);

      setRegisterTo((((activePage - 1) * itensByPage) + 1) + (itensByPage - 1));
      if (((((activePage - 1) * itensByPage) - 1) + (itensByPage - 1)) > total) {
        setRegisterTo(total);
      }
      setRegisterFrom(((activePage - 1) * itensByPage) + 1);
    }
  }
  
  function searchWarehousesFrom(e) {
    setWarehouseFrom(e.target.value);
    
    clearTimeout(delay);
    
    delay = setTimeout(() => {
      api.get("/api/warehouses/getSearchWarehouses?term=" + e.target.value.toLowerCase())
      .then((response) => {
        setListWarehousesFrom(response.data.list);
      }).catch((error) => {
        showMessageError(error.response.data);
      });
    }, 750);
  }
  
  function searchWarehousesTo(e) {
    setWarehouseTo(e.target.value);
    
    clearTimeout(delay);
    
    delay = setTimeout(() => {
      api.get("/api/warehouses/getSearchWarehouses?term=" + e.target.value.toLowerCase())
      .then((response) => {
        setListWarehousesTo(response.data.list);
      }).catch((error) => {
        showMessageError(error.response.data);
      });
    }, 750);
  }
  
  function searchAddressesFrom(e) {
    setAddressFrom(e.target.value);
    
    clearTimeout(delay);
    
    delay = setTimeout(() => {
      api.get("/api/adresses/searchAdresses?term=" + e.target.value.toLowerCase())
      .then((response) => {
        setListAddressesFrom(response.data.adresses);
      }).catch((error) => {
        showMessageError(error.response.data);
      });
    }, 750);
  }
  
  function searchAddressesTo(e) {
    setAddressTo(e.target.value);
    
    clearTimeout(delay);
    
    delay = setTimeout(() => {
      api.get("/api/adresses/searchAdresses?term=" + e.target.value.toLowerCase())
      .then((response) => {
        setListAddressesTo(response.data.adresses);
      }).catch((error) => {
        showMessageError(error.response.data);
      });
    }, 750);
  }
  
  function searchProductsFrom(e) {
    setProductFrom(e.target.value);
    
    clearTimeout(delay);
    
    delay = setTimeout(() => {
      api.get("/api/products/getSearchProduct?term=" + e.target.value.toLowerCase())
      .then((response) => {
        setListProductsFrom(response.data.list);
      }).catch((error) => {
        showMessageError(error.response.data);
      });
    }, 750);
  }
  
  function searchProductsTo(e) {
    setProductTo(e.target.value);
    
    clearTimeout(delay);
    
    delay = setTimeout(() => {
      api.get("/api/products/getSearchProduct?term=" + e.target.value.toLowerCase())
      .then((response) => {
        setListProductsTo(response.data.list);
      }).catch((error) => {
        showMessageError(error.response.data);
      });
    }, 750);
  }

  return (
    <div>
      <Header />
      <Division />
      <Lateral />
      <ReactTooltip />

      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Cadastro de Inventário">
          <Link to="/inventory">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Inventário</h2>
              <hr></hr>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Descrição</label>&nbsp;<label className="required">*</label><br />
                  <input type="text" placeholder="Descrição" value={description} onChange={(e) => setDescription(e.target.value)} maxLength="200" />
                </div>

                <div className="formDiv">
                  <label>Status</label><br />
                  <select value={status} onChange={(e) => setStatus(e.target.value)} disabled={true}>
                    <option value="">Selecione</option>
                    {listStatus.map((item, index) => (
                      <option key={index} value={item.chave}>{item.chave} - {item.descricao}</option>
                    ))}
                  </select>
                </div>

                <div className="formDiv">
                  <label>Data Criação</label><br />
                  <InputDate filters={infos} setFilters={setInfos} propertyFilter="date" disabled />
                </div>

                <div className="formDiv">
                  <label>Hora Criação</label><br />
                  <input type="text" placeholder="##:##:##" value={hour} onChange={(e) => setHour(setMaskGeneric(e.target.value, "##.##.##"))} maxLength="8" disabled={true} />
                </div>
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Observacao</label>&nbsp;<label className="required">*</label><br />
                  <input type="text" placeholder="Observação" value={observation} onChange={(e) => setObservation(e.target.value)} maxLength="200" />
                </div>
              </div>
            </div>
            <br />

            <div className="containerGroupData">
              <h2>Geração de Inventário</h2>
              <hr></hr>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Armazém</label><br />
                  <input type="text" placeholder="Armazém" value={warehouse_from} onChange={searchWarehousesFrom} maxLength="200" disabled={view} />
                  <ul className="dropdown-menu">
                    {listWarehousesFrom.map((item, index) => (
                      <li key={index} onClick={() => {setWarehouseFrom(item.codigo_armazem); setListWarehousesFrom([])}}>
                        <a>{item.descricao}</a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="formDiv">
                  <label>até Armazém</label><br />
                  <input type="text" placeholder="Armazém" value={warehouse_to} onChange={searchWarehousesTo} maxLength="200" disabled={view} />
                  <ul className="dropdown-menu">
                    {listWarehousesTo.map((item, index) => (
                      <li key={index} onClick={() => {setWarehouseTo(item.codigo_armazem); setListWarehousesTo([])}}>
                        <a>{item.descricao}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Endereço</label><br />
                  <input type="text" placeholder="Endereço" value={address_from} onChange={searchAddressesFrom} maxLength="200" disabled={view} />
                  <ul className="dropdown-menu">
                    {listAddressesFrom.map((item, index) => (
                      <li key={index} onClick={() => {setAddressFrom(item.nome); setListAddressesFrom([])}}>
                        <a>{item.nome}</a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="formDiv">
                  <label>até Endereço</label><br />
                  <input type="text" placeholder="Endereço" value={address_to} onChange={searchAddressesTo} maxLength="200" disabled={view} />
                  <ul className="dropdown-menu">
                    {listAddressesTo.map((item, index) => (
                      <li key={index} onClick={() => {setAddressTo(item.nome); setListAddressesTo([])}}>
                        <a>{item.nome}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Produto</label><br />
                  <input type="text" placeholder="Produto" value={product_from} onChange={searchProductsFrom} maxLength="200" disabled={view} />
                  <ul className="dropdown-menu">
                    {listProductsFrom.map((item, index) => (
                      <li key={index} onClick={() => {setProductFrom(item.codigo_produto); setListProductsFrom([])}}>
                        <a>{item.codigo_produto} - {item.descricao}</a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="formDiv">
                  <label>até Produto</label><br />
                  <input type="text" placeholder="Produto" value={product_to} onChange={searchProductsTo} maxLength="200" disabled={view} />
                  <ul className="dropdown-menu">
                    {listProductsTo.map((item, index) => (
                      <li key={index} onClick={() => {setProductTo(item.codigo_produto); setListProductsTo([])}}>
                        <a>{item.codigo_produto} - {item.descricao}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <br />

            <div className="containerGroupData">
              <div className="formDivList">
                <div className="containerGroupData">
                  <button type="button" className="buttonClear" onClick={clearList} disabled={view}>Limpar Lista</button>
                  <select className='selectQtdeItens' value={itensByPage} onChange={(e) => { setItensByPage(e.target.value); setPagination(listAll, e.target.value); }}>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="40">40</option>
                    <option value="50">50</option>
                  </select>
                  <input className="inputSearch" type="text" onChange={search} placeholder="Pesquisar" />
                  <FaSearch className="iconSearch" style={{ color: '#001675' }} size={16} />
                  
                  <h2>Selecionados&nbsp;<label className="required">*</label></h2>
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">Armazém</th>
                        <th scope="col">Endereço</th>
                        <th scope="col">Produto</th>
                        <th className='collumOption' scope="col">Opções</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.warehouse_description}</td>
                            <td>{item.address_description}</td>
                            <td>{item.product_description}</td>
                            <td>
                              <Link className="action" onClick={() => removeItem(index)}>
                                <FaTrash color="#000" size={17} />
                              </Link>
                            </td>
                          </tr>
                        )
                      })}
                      {list.length == 0 && <tr>
                        <td colSpan={4}><label className='required'>Nenhum registro encontrado!</label></td>
                      </tr>}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="divGroupPagination">
                <button data-tip="Primeira página" type="button" onClick={firstPage} className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft color="#001675" size={17} /></button>
                <button data-tip="Página anterior" type="button" onClick={previewPage} className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
                <div className="divLabelPagination">
                  <center><label className="labelPage">{registerFrom} - {registerTo} de {total}</label></center>
                </div>
                <button data-tip="Próxima página" type="button" onClick={nextPage} className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
                <button data-tip="Última página" type="button" onClick={lastPage} className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight color="#001675" size={17} /></button>
              </div>
            </div>

            <div className="formDiv" style={{display: "flex", gap: "0.5rem"}}>
              <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
              <button type="button" className="buttonSubmit" onClick={addItemInventory} disabled={view}>Gerar</button>
            </div>
          </form>
        </div>
      </div>}
    </div>
  )
}